<template>
  <div id="gallery" class="gallery-wrap pb-75">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style3 text-center mb-40">
            <span>Gallery Exhibition</span>
            <h2>Discover Your Eye Health From Our Medical Clinic</h2>
          </div>
        </div>
      </div>

      <div class="gallery-item-wrap style5">
        <div
          class="gallery-card style8"
          v-for="gallery in galleries"
          :key="gallery.id"
        >
          <div class="gallery-img">
            <img :src="gallery.image" alt="Image" />

            <div class="gallery-info">
              <router-link class="gallery-icon" to="/gallery-details">
                <i class="ri-add-line"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "GalleryExhibition",
  data: () => ({
    galleries: [
      {
        id: 1,
        image: require("../../assets/images/gallery/gallery-40.jpg"),
      },
      {
        id: 2,
        image: require("../../assets/images/gallery/gallery-41.jpg"),
      },
      {
        id: 3,
        image: require("../../assets/images/gallery/gallery-42.jpg"),
      },
      {
        id: 4,
        image: require("../../assets/images/gallery/gallery-43.jpg"),
      },
      {
        id: 5,
        image: require("../../assets/images/gallery/gallery-44.jpg"),
      },
      {
        id: 6,
        image: require("../../assets/images/gallery/gallery-45.jpg"),
      },
    ],
  }),
});
</script>